import React, { useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { VariableSuppliers } from './VariableSuppliers';
import SelectDropDown from '../../../../components/elements/SelectDropDown';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'

function FilterSuppliers({ translate, noPadding, bigTitle }) {
    const { dispatch, navigate, langLocal } = AbstructVar()
    const { state, setStateCustom, setLoad, handleChangeDate } = VariableSuppliers();
    const [supplierId, setSupplierId] = useState('')
    const [materialId, setMaterialId] = useState('')
    const Filter = (e) => {
        e.preventDefault()
        //dispatch(filterEvaluationType(state.name, state.creative_work_type_id, setLoad))
    }
    return (
        <div className='filteruser ' dir={langLocal === 'ar' ? "rtl" : "ltr"} style={noPadding && { padding: "4px 0px 10px 0px" }} >
            {
                bigTitle ? <h2 className="main_title_color" >{translate('search_filter')}</h2> :
                    <h3>{translate('search_filter')}</h3>
            }
            <div className='div_filter' style={{ marginTop: '0px' }} >
                <div className={`${langLocal === 'ar'? "margin_left_10": "margin_right_10"} one-select w-24`}  style={{fontSize: "14px"}} >
                    <span>{translate('supplier')}</span>
                    <SelectDropDown
                        options={[{ value: 'Supplier1', label: "Supplier1" }, { value: 'Supplier2', label: "Supplier2" }]}
                        varr={supplierId}
                        setVarr={(value) => setSupplierId(value)}
                    />
                </div>
                <div className={`${langLocal === 'ar'? "margin_left_10": "margin_right_10"} one-select w-24`}  style={{fontSize: "14px"}} >
                    <span>{translate('materials')}</span>
                    <SelectDropDown
                        options={[{ value: 'Material1', label: "Material1" }, { value: 'Material2', label: "Material2" }]}
                        varr={materialId}
                        setVarr={(value) => setMaterialId(value)}
                    />
                </div>
                <div className={`${langLocal === 'ar'? "margin_left_10": "margin_right_10"} one-select w-24`} >
                    <span>{translate('date')}</span>
                    <DatePicker
                        selected={state.startDate}
                        onChange={handleChangeDate}
                        startDate={state.startDate}
                        endDate={state.endDate}
                        selectsRange
                        placeholderText='Select Date'
                        className='date_inn'
                    />
                </div>
                <button className='btn_filter' onClick={Filter} style={{ marginBottom: "0px", marginTop: "30px" }} >
                    {
                        state.Load ? "Loading ..." : `${translate('filter')}`
                    }
                </button>
            </div>
        </div>
    )
}

export default FilterSuppliers